const appBaseUrl = '/';

if (typeof (window as any).SL === 'undefined') {
  loadJQuery();
  loadScript(appBaseUrl + 'slidePrevious/lib/jquery/jquery-2.2.3.js');
  loadScript(appBaseUrl + 'slidePrevious/lib/jquery.cookie.js');
  //
  loadScript(appBaseUrl + 'slidePrevious/lib/ui/jquery-ui.js');
  loadStyle(appBaseUrl + 'slidePrevious/lib/ui/jquery-ui.css');

  loadScript(appBaseUrl + 'slidePrevious/lib/md5.js');

  loadScript(appBaseUrl + 'slidePrevious/lib/colorpicker/js/farbtastic.js');
  loadStyle(appBaseUrl + 'slidePrevious/lib/colorpicker/css/farbtastic.css');

  loadScript(appBaseUrl + 'slidePrevious/js/slidePathology.js');
  loadStyle(appBaseUrl + 'slidePrevious/css/slidepath.css');

  // loadScript(appBaseUrl + 'static/slideLib/specs.global.js');

  // if (!isMobile()) {
  //   loadScript(Const.appBaseUrl + 'static/unity/UnityLoader.js');
  // }
}

function loadScript(url: string) {
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = url;
  script.async = false;

  document.body.appendChild(script);
}

function loadJQuery() {
  // let html = `<script>window.$ = window.jQuery = require("${appBaseUrl + 'slidePrevious/lib/jquery/jquery-2.2.3.js'}")</script>`;
  const html = '<script>if (typeof module === "object") {window.module = module;module = undefined;}</script>';
  document.body.insertAdjacentHTML('beforeend', html);
  const oldScript = document.body.getElementsByTagName('script')[0];
  document.body.removeChild(oldScript);
  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  newScript.innerHTML = oldScript.innerHTML;
  document.body.appendChild(newScript);
}

function loadStyle(url: string) {
  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = url;

  document.head.appendChild(link);
}
